















































import {Vue, Component} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {Povratnica, StavkaDokumenta} from "@/services/BackendProxies";
import {focusCena} from "@/utils/focusFunctions";

@Component({})
export default class PotvrdaPovratnice extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    povratnica = Povratnica.fromJS({datum: new Date()});
    columns = [];
    isBusy = false;

    async created() {
        this.columns = [
            {field: 'sifra', title: this.$i18n.t('sifra'), width: 200},
            {field: 'kataloskiBroj', title: this.$i18n.t('kataloskiBroj'),width: 200},
            {field: 'opis', title: this.$i18n.t('naziv')},
            {field: 'kolicina',title: this.$i18n.t('kolicina'),width: 120},
            {field: 'utrosenaKolicina',title: this.$i18n.t('potvrdjenaKolicina'),formatter: this.potvrdjenaKolicinaFormatter,width: 120},
         //   {field: 'action', align: 'right', width: 30, formatter: `<i class="fa fa-trash text-danger"></i>`}
        ];
    }

    potvrdjenaKolicinaFormatter(value, row, index) {
        return this.vueFormatter({
            template: `<input class="form-control" @change="focusCena($event, 'data-kolicina', 'kolicina')" ref="test"
                              :class="{invalid: isNaN(row.utrosenaKolicina) || row.utrosenaKolicina < 0 || row.kolicina < row.utrosenaKolicina}"
                              data-kolicina="${index}" style="text-align: right" v-model.number.lazy="row.utrosenaKolicina"
                              type="text">`,
            data: {row},
            methods: {focusCena: focusCena}
        });
    }

    novaPovratnica() {
        this.povratnica = Povratnica.fromJS({datum: new Date(),stavke: []});
    }

    async sacuvajPovratnicu() {
        if (this.isBusy) return;
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            try {
                this.isBusy = true;
                this.povratnica = await this.saveData(() => dataProxy.sacuvajPovratnicu(this.povratnica))();
            } finally {
                this.isBusy = false;
            }

        } else {
            this.showInfo('nisu sva obavezna polja popunjena');
        }
    }

    async zakljuciPovratnicu() {
        if (this.isBusy) return;
        let da = await this.confirmationNeeded('da li zelite da zakljucite dokument');
        if (da) {
            try {
                this.isBusy = true;
                this.saveData(() => dataProxy.zakljuciPovratnicu(this.povratnica))();
                this.novaPovratnica();
            } finally {
                this.isBusy = false;
            }
        }
    }

    async onUnetBrojDokumenta(id: number) {
        if (id) {
            const povratnica = await this.loadData(() => dataProxy.vratiPovratnicuPoId(id))();
            if (!povratnica) {
                this.showInfo('dokument nije moguce ucitati');
            } else {
                this.povratnica = povratnica;
            }
        }
    }

    postBody() {
        this.vueFormatterPostBody();
        const input = $('input.invalid');
        if (input.length) {
            this.$nextTick(() => input[0].focus());
        }
    }
}
